/*
 * @Author: your name
 * @Date: 2021-07-27 17:55:39
 * @LastEditTime: 2021-10-19 17:17:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \foxit_print\src\utils\miniprogram.js
 */
/*
 * @Author: your name
 * @Date: 2021-07-27 17:19:59
 * @LastEditTime: 2021-07-27 17:46:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \cloud_doc\src\utils\miniprogram.js
 */

import { asyncLoadJs } from "./utils";

export default class Miniprogram {
  instance = null;
  api = null;
  hadInit = false;

  init() {
    return new Promise(async (resolve, reject) => {
      if (this.hadInit) {
        resolve(this.instance);
      } else {
        const instance = await this.getMiniprogramInstance();
        this.instance = instance;
        this.api = instance.miniProgram;
        resolve(instance);
      }
    });
  }

  getMiniprogramInstance() {
    return new Promise(async (resolve, reject) => {
      // QQ小程序中也存在微信环境变量 用else判断
      if (window.__qqjs_environment === "miniprogram") {
        await asyncLoadJs(
          "https://qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js"
        );
        resolve(qq);
      } else {
        await asyncLoadJs("https://res.wx.qq.com/open/js/jweixin-1.3.2.js");
        resolve(wx);
      }
    });
  }
}
